var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusD({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#3872B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-plus",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusD);
export default __webpack_public_path__ + "static/media/plusD.059c43e02bd2095b9683edff558733b6.svg";
export { ForwardRef as ReactComponent };